module.exports = __webpack_public_path__ + "static/media/userDirectory.d0766bc9.jpg";